import { ApplicationQuoteType, isLoanSideDeal } from '@amsanalytics/react-shared-library';

/**
 * True when `appStatusId` is one of the tenant's locked application statuses.
 *
 * `lockedApplicationStatuses` comes from `api/configuration` (the `LockedApplicationStatuses`
 * client configuration item resolved by the API), so the UI and API agree on which statuses lock.
 * The comparison ignores GUID casing: the API serializes GUIDs in lower case while other client
 * code uses upper case.
 *
 * While the configuration has not loaded yet (`undefined`), an application that has a status is
 * treated as locked so nothing is briefly editable that the API would reject. An empty list means
 * no status locks, matching the server-side resolver.
 */
export const isLockedApplicationStatus = (
  appStatusId: string | undefined | null,
  lockedApplicationStatuses: string[] | undefined | null
): boolean => {
  if (!appStatusId) return false;
  if (!lockedApplicationStatuses) return true;

  const statusId = appStatusId.toLowerCase();
  return lockedApplicationStatuses.some(lockedStatusId => lockedStatusId.toLowerCase() === statusId);
};

/**
 * The notice for a refinance or side note, which the LOS opens read-only for everyone (they are worked in
 * DealerFlow 360; the API refuses the LOS's writes to them); null for every other application.
 */
export const loanSideDealReadOnlyMessage = (quoteType: ApplicationQuoteType | number | null | undefined): string | null =>
  isLoanSideDeal(quoteType)
    ? `This ${quoteType === ApplicationQuoteType.SideNote ? 'side note' : 'refinance'} is worked in DealerFlow 360. It is read-only in the LOS.`
    : null;
